'use client';

import { datadogRum } from '@datadog/browser-rum';

/**
 * Destrava a gravação da sessão já sorteada pelo `sessionReplaySampleRate`.
 *
 * Chamado no `SessionIdProvider` só depois de o `createSession` responder: link
 * inválido, expirado ou 404 não consome cota de replay. Não pode ser mais tarde
 * (replay não tem rewind) nem mais cedo (pagaria por link inválido).
 */
export function startSessionReplay(): void {
  if (typeof window === 'undefined') return;

  try {
    datadogRum.startSessionReplayRecording();
  } catch {
    // Observabilidade não derruba checkout.
  }
}
